import { InteractionType } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import React, { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { msalConfig } from "../config/msalConfig";
import { USER_AUTH_TYPE } from "../enums/user-auth-type.enum";
import { UserPartial } from "../models/user.model";
import AccessDenied from "./AccessDenied";
import LoadingPlaceholder from "./LoadingPlaceholder";

type EmployeeAuthenticatedRouteProps = {
  children: ReactNode;
};

/** Authenticates a standalone employee tool without relying on invite query parameters. */
export default function EmployeeAuthenticatedRoute({ children }: EmployeeAuthenticatedRouteProps) {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated || inProgress !== InteractionType.None) return;

    void instance.loginRedirect({
      authority: `${process.env.REACT_APP_MSAL_AUTHORITY}/${USER_AUTH_TYPE.COMARCH_EMPLOYEE}`,
      scopes: msalConfig.auth.scopes,
      redirectStartPage: `${window.location.origin}${location.pathname}${location.search}`,
    });
  }, [inProgress, instance, isAuthenticated, location.pathname, location.search]);

  if (!isAuthenticated || inProgress !== InteractionType.None) {
    return <LoadingPlaceholder />;
  }

  const claims = accounts[0]?.idTokenClaims as UserPartial | undefined;
  if (claims?.acr !== USER_AUTH_TYPE.COMARCH_EMPLOYEE) {
    return <AccessDenied />;
  }

  return <>{children}</>;
}
